import * as React from 'react';
import { Collapse, Container, NavbarBrand, NavbarToggler, NavItem, Navbar, Button } from 'reactstrap';
import { Link, NavLink} from 'react-router-dom';
import './NavMenu.css';
import { connect } from 'react-redux';


function mapStateToProps(state: any) {
    const { loggingIn, user } = state.authentication;
    
    return {
        loggingIn: loggingIn,
        user: user
    };
}
export class NavMenu extends React.PureComponent<{ loggingIn: boolean, user: any}, { isOpen: boolean}> {
   
   public state = {
        isOpen: false,
    };


    public render() {
       const { loggingIn, user } = this.props;
       let loggedIn = user === 'null' ? false : loggingIn;
     
          return (
            <header>
                <Navbar className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-dark border-bottom box-shadow mb-3" dark >
                     <Container>
                          <a className="navbar-brand text-white" asp-area="" asp-controller="Home" asp-action="Index"> <img src="/content/img/OTD-logo-white.png" className="otdlogo" /></a>
                          <NavbarToggler onClick={this.toggle} className="mr-2" />
                          {loggedIn && (
                            
                              <ul className="navbar-nav flex-grow">
                                  <NavItem className="nav-item otdgreycolour">
                                      <NavLink className="nav-link text-white disabled-link" style={{ pointerEvents: 'none' }}  to="/OutletSearch-Form">Outlet Search</NavLink>
                                  </NavItem> 
                                  <NavItem className="nav navbar-nav navbar-right" >
                                      <NavLink  className="nav-link text-white" to="/login">Logout</NavLink>
                                  </NavItem>
                               </ul>
                          )}
                        
                      </Container>
                    
                </Navbar>
     
            </header>
           
        );
    }

    private toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }


}

export default connect(mapStateToProps)(NavMenu as any);


